import { render, staticRenderFns } from "./RectanglePlasticBadge.vue?vue&type=template&id=48243b8b&scoped=true&"
import script from "./RectanglePlasticBadge.vue?vue&type=script&lang=js&"
export * from "./RectanglePlasticBadge.vue?vue&type=script&lang=js&"
import style0 from "./RectanglePlasticBadge.vue?vue&type=style&index=0&id=48243b8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48243b8b",
  null
  
)

component.options.__file = "RectanglePlasticBadge.vue"
export default component.exports